

import { SvgIcon, SvgIconProps } from '@mui/material';

export default function WindowBookmarkIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.50999 3.75305C1.50999 2.92462 2.18157 2.25305 3.00999 2.25305H21.01C21.8384 2.25305 22.51 2.92462 22.51 3.75305V20.2531C22.51 21.0815 21.8384 21.7531 21.01 21.7531H3.01C2.18157 21.7531 1.50999 21.0815 1.50999 20.2531V3.75305Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.50999 6.75305H22.51"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.51 17.2531L17.571 15.3141C17.2897 15.0325 16.908 14.8744 16.51 14.8744C16.112 14.8744 15.7303 15.0325 15.449 15.3141L13.51 17.2531V6.75305H19.51V17.2531Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
